<template>
  <div>
     <template class="table-head">
        <el-table style="width: 100%" @current-change="handleCurrentChange" highlight-current-row  :data="tableDataLists" border height="200" ref="dragTable">
            <el-table-column align="center" show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width" v-for="(item, index) in netWorkDotDetailColumnItem" :key="index">
                    <template slot-scope="scope">
                        <span class="center">
                            <span >{{scope.row[item.prop]}}</span>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        <div class="pagination">
            <el-pagination small layout="prev, pager, next" @current-change="pageChange" :total="tableDataListsLenth"></el-pagination>
        </div>
     </template>
  </div>
</template>

<script>
export default {
    props: {
        netWorkDotDetailColumnItem: {
            type: Array
        },
        tableDataListsLenth: {
            type: Number,
            default: 0
        },
        tableDataLists: {
            type: Array
        }
    },
    methods: {
        handleCurrentChange() {
        },
        pageChange(page) {
            this.$emit('apBillDeDetail', page);
        },
        saveDistributionDetails() {
        }
    }

};
</script>

<style lang="less">

</style>